import 'babel-polyfill';
import riot from "riot";
import Viewer from "./tags/viewer";

// if (module.hot) {
//   module.hot.accept('./tags/viewer', () => {
//     window.Viewer = require('./tags/viewer').default;
//     const view = window.view;
//     if (view) {
//       view.unmount(true);
//       window.viewer = window.Viewer(view.root, view.opts);
//     }
//     if (window.onHotReload) window.onHotReload();
//   });
// }
riot.viewer = Viewer;
export default riot;
